import React, { useMemo } from 'react';

import { debounce } from 'lodash';
import { GroupBase, StylesConfig } from 'react-select';
import AsyncSelect from 'react-select/async';
import { SelectStyle } from 'src/accounts/utils';

import { fetchParentAccounts } from '../api';
import { ParentAccountOption } from '../types';

type Props = {
  value: ParentAccountOption | null;
  onChange: (value: ParentAccountOption | null) => void;
};

type LoadCallbackType = (options: ParentAccountOption[]) => void;

const ParentAccountSelect: React.FC<Props> = ({ value, onChange }) => {
  const loadOptions = (input: string, callback: LoadCallbackType): void => {
    fetchParentAccounts(input)
      .then((options) => callback(options))
      .catch(() => callback([]));
  };

  const debouncedLoadOptions = useMemo(() => debounce(loadOptions, 500), []);

  return (
    <AsyncSelect
      styles={
        SelectStyle as StylesConfig<ParentAccountOption, false, GroupBase<ParentAccountOption>>
      }
      aria-label="Parent account"
      cacheOptions
      defaultOptions
      loadOptions={debouncedLoadOptions}
      value={value}
      onChange={(option) => onChange(option as ParentAccountOption | null)}
      getOptionLabel={(option: ParentAccountOption) => option.name}
      getOptionValue={(option: ParentAccountOption) => option.id}
      placeholder="Select a parent account"
      className="w-full"
    />
  );
};

export default ParentAccountSelect;
